import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-student-contact-card-placeholder',
  templateUrl: './student-contact-card-placeholder.component.html',
  styleUrls: ['./student-contact-card-placeholder.component.scss']
})
export class StudentContactCardPlaceholderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
